import { createAuth0 } from "@auth0/auth0-vue";

const auth0 = createAuth0({
  authorizationParams: {
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    redirect_uri: `${window.location.origin}${import.meta.env.VITE_AUTH0_CALLBACK_PATH}`,
  },
  cacheLocation: 'memory',
  // cacheLocation: 'localstorage',
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  useRefreshTokens: true,
  useRefreshTokensFallback: true,
}, {
  errorPath: '/auth-error',
});

export default auth0;
